import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const initialState = {
  selectedUser: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      if (action.payload !== null) {
        //
        return action.payload;
      } else {
        return null;
      }
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    getUser: (action) => {},
    patchUser: (state, action) => {},
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const { setUser, getUser, patchUser, setSelectedUser } =
  userSlice.actions;
export default userSlice.reducer;
